import { Button, Col, Divider, Form, Input, Select, Space } from "antd";
import  get from "lodash/get";
import  map from "lodash/map";
import { PlusOutlined } from "@ant-design/icons";

const OperatorInput =({staffList, setNewStaff, newStaff, onAddOperator})=>{
    return(
        <Col md={4} xs={24}>
            <Form.Item
              label="Operator"
              name="operator"
              rules={[
                {
                  required: true,
                  message: "Please select Operator...!",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Operator"
                options={map(get(staffList, 'operatorList'), (operator) => ({
                  label: operator,
                  value: operator,
                }))}
                size="small"
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space size={[24, 24]} className="justify-center pl-2" wrap>
                      <Input
                        placeholder="Add new operator"
                        value={get(newStaff, "newOperator")}
                        className="w-full"
                        size="small"
                        onChange={(e) => setNewStaff({...newStaff,newOperator:e.target.value})}
                      />

                      <Button
                        type="link"
                        icon={<PlusOutlined />}
                        disabled={get(newStaff, "newOperator") ? false : true}
                        onClick={() => {
                          onAddOperator();
                        }}
                        size="small"
                      >
                        Add Operator
                      </Button>
                    </Space>
                  </>
                )}
              />
            </Form.Item>
          </Col>
    )
}
export default OperatorInput